import { render } from "./ReportView.vue?vue&type=template&id=23f5bdf4"
import script from "./ReportView.vue?vue&type=script&lang=js"
export * from "./ReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__